import { dispatch } from '@rematch/core';
import { accountUsersService } from '../../services/feathers.service';
import { toastr } from 'react-redux-toastr';

const initialState = {
  isModalOpen: false,
  changePwdError: null
};

export default {
  state: {},
  reducers: {
    setModalOpen(state, payload) {
      return {
        ...state,
        isModalOpen: payload
      }
    },
    setError(state, payload) {
      return {
        ...state,
        changePwdError: payload,
      }
    },
    clear() {
      return initialState
    },
  },
  effects: {
    async changePassword(payload) {
      var id = payload.id;
      delete payload.id;
      try {
        await accountUsersService.patch(id, payload);
        toastr.success('Message', 'Password successfully updated.');
        dispatch.profile.setModalOpen(false);
      } catch (err) {
        // toastr.error('Message', err.message);
        dispatch.profile.setError(err);
      }

    },
    async changeUserName(payload) {
      var id = payload.id;
      delete payload.id;

      try {
        dispatch.app.modifyUserName(payload);
        await accountUsersService.patch(id, payload);
        toastr.success('Message', 'User details successfully updated.');
      } catch (err) {
        toastr.error('Message', 'Failed to update the User Details.');
      }
      dispatch.profile.setModalOpen(false);
    },

    modalOpen(onOffState) {
      dispatch.profile.setModalOpen(onOffState);
      dispatch.profile.setError(null);
    },

  },
}